import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=2db61698&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"
import style0 from "./_slug.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default,SgImg: require('/opt/build/repo/storefront/components/legacy/global/sg-img.vue').default,Flag: require('/opt/build/repo/storefront/components/legacy/global/flag.vue').default,DynamicImg: require('/opt/build/repo/storefront/components/legacy/global/dynamic-img.vue').default,ProductName: require('/opt/build/repo/storefront/components/legacy/global/product-name.vue').default})
